import { render, staticRenderFns } from "./ComprasPorArrematante.vue?vue&type=template&id=c4dba520"
import script from "./ComprasPorArrematante.vue?vue&type=script&lang=js"
export * from "./ComprasPorArrematante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports